<div class="notification-bell">
  <button type="button" class="bell-button" (click)="toggle()"
    [attr.aria-label]="unreadCount > 0 ? unreadCount + ' notificaciones nuevas' : 'Notificaciones'"
    data-cy="campanita">
    <i class="far fa-bell"></i>
    @if (unreadCount > 0) {
      <span class="bell-badge" data-cy="campanita contador">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    }
  </button>

  @if (open) {
    <div class="bell-panel" data-cy="campanita panel">
      <div class="bell-panel-title">Notificaciones</div>

      @if (loading) {
        <div class="bell-empty">Cargando…</div>
      } @else if (loaded && notifications.length === 0) {
        <div class="bell-empty">No tienes notificaciones</div>
      } @else {
        <ul class="bell-list">
          @for (n of notifications; track n.kind + '-' + n.refid) {
            <li class="bell-item" [class.bell-item-unread]="n.unread" (click)="go(n)">
              <i class="bell-item-icon" [ngClass]="iconFor(n)"></i>
              <div class="bell-item-body">
                <div class="bell-item-title">{{ n.title }}</div>
                <div class="bell-item-text">{{ n.text }}</div>
                <div class="bell-item-date">{{ n.date | date:'dd-MM-yyyy' }}</div>
              </div>
            </li>
          }
        </ul>
      }

      <a class="bell-footer" routerLink="/notificaciones" (click)="open = false">Ver todas</a>
    </div>
  }
</div>
